export default __webpack_public_path__ + "static/media/phone.3cf6a66a.png";